/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitType
 */
export interface MonitType {
}

/**
 * Check if a given object implements the MonitType interface.
 */
export function instanceOfMonitType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitTypeFromJSON(json: any): MonitType {
    return MonitTypeFromJSONTyped(json, false);
}

export function MonitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitType {
    return json;
}

export function MonitTypeToJSON(value?: MonitType | null): any {
    return value;
}

